export const getMinutesFromTime = (time: string) => {
  const [hour, minutes] = time.split(':');

  return +hour * 60 + +minutes;
};
